var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var RectangleData = require('../../../svg/rectangleData.js');
var IPCRules = require('../ipcRules');
var DfnPackageWithIdenticalPadsData = require('./dfnPackageWithIdenticalPadsData.js');

var Dfn4Data = function(position, angle, init) {
    DfnPackageWithIdenticalPadsData.apply(this, arguments);
};
lib_core.inherit(Dfn4Data, DfnPackageWithIdenticalPadsData);
lib_core.JsonParser.registerClass(Dfn4Data, "Dfn4Data");

module.exports = Dfn4Data;

Dfn4Data.prototype.getSilkscreen = function(pads) {
  var silkscreen = [];

  //no silkscreen if there are no pads
  if(pads.length === 0) return silkscreen;

  ////////////////////
  //   Pin Marker   //
  ////////////////////

  //get body dimesnsions depending on mapping type of silkscreen to body
  var body = this.getBodyForSilkscreen();
  var firstPad = pads[0];
  var secondPad = pads[1];

  ////////////////////
  //   Pin Marker   //
  ////////////////////

  silkscreen.push(this.getPinOneMarker(firstPad, body, true));

  //////////////////////////////
  //   Component Silkscreen   //
  //////////////////////////////
    
  var topLineY;
  var bottomLineY;
  var pathData;

  if(firstPad.getPos().y + firstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
      topLineY = firstPad.getPos().y + firstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2;
      bottomLineY = secondPad.getPos().y - secondPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;
  } else {
      topLineY = body.height / 2;
      bottomLineY = - body.height / 2;
  }

  //top line
  pathData = new PathData(new lib_geometry.Coord(body.width / 2, topLineY), IPCRules.silkscreenStrokeWidth);
  pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, topLineY), PathType.LINE));
  silkscreen.push(pathData);

  //bottom line
  pathData = new PathData(new lib_geometry.Coord(body.width / 2, bottomLineY), IPCRules.silkscreenStrokeWidth);
  pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, bottomLineY), PathType.LINE));
  silkscreen.push(pathData);


  return silkscreen;
};
